var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4438 2.19091C6.74723 1.80447 6.69751 1.23029 6.33408 0.907652C5.97065 0.585015 5.42978 0.637876 5.12721 1.02431L0.841438 5.58133C0.807152 5.62417 0.790866 5.67521 0.765151 5.7226C0.744579 5.75997 0.720579 5.79278 0.70515 5.83379C0.665721 5.94043 0.642578 6.05162 0.642578 6.16463C0.642578 6.27765 0.665721 6.38884 0.70515 6.49547C0.720579 6.53649 0.744579 6.5693 0.765151 6.60666C0.790866 6.65406 0.807152 6.70509 0.841438 6.74793L5.12721 11.305C5.42978 11.6923 5.97065 11.7442 6.33408 11.4216C6.69751 11.0999 6.74723 10.5257 6.4438 10.1384L3.32976 7.07604L2.47268 6.16471L3.33183 5.25118L6.4438 2.19091Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.78b31c270b38559ecf500a4d8ec629b5.svg";
export { ForwardRef as ReactComponent };